<template>
  <el-button :type="type"
             :size="size"
             :round="round"
             :loading="buttonStatus"
             :disabled="disabled"
             :plain="plain"
             @click="onclick"
             class="butt"
             :class="{bgcGray:buttonStatus}"
  >{{title}}
  <slot></slot>
  </el-button>
</template>

<script>
  import {mixin} from '../libs/mixs.js'
    export default {
      mixins: [mixin],
        name: "buttonW",
      props: {
        round:{
          type: Boolean,
          default: false
          },
        plain:{
          type: Boolean,
          default: false
        },
        disabled:{
          type: Boolean,
          default: false
        },
        type:{
          type: String,
          default: 'primary'
        },
        clickState: {
          type: Boolean,
          default: false
        },
        title: {
          type: String,
          default: ''
        },
        state: {
          type: Boolean,
          default: true
        },
        size: {
          type: String,
        },
      },
      data() {
        return {
          buttonStatus: false,
          stopTime: null,
          buttonTimeOut:null
        }
      },
      methods:{
        onclick(){
          if (!this.buttonStatus) {
            let _self = this;
            this.axios.interceptors.request.use(function (config) {
              // 在发送请求之前做些什么
              _self.buttonStatus = true;
              clearTimeout(_self.buttonTimeOut)
              return config;
            }, function (error) {
              // 对请求错误做些什么
              _self.buttonStatus = true;
              clearTimeout(_self.buttonTimeOut)
              return Promise.reject(error);
            });
            this.axios.interceptors.response.use(function (response) {
              // 对响应数据做点什么
              _self.buttonTimeOut = setTimeout(function(){
                _self.buttonStatus = false;
              },800);
              return response;
            }, function (error) {
              _self.buttonTimeOut = setTimeout(function(){
                _self.buttonStatus = false;
              },800);
              // 对响应错误做点什么
              return Promise.reject(error);
            });
            this.$emit('onclick');
          }
        },
      },
      created(){
        this.buttonStatus = this.clickState;
      }
    }
</script>

<style lang="less" scoped>
  .bgcGray{
    opacity:0.5;
  }
</style>
